import { Button, Typography } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { ResourceHeaderProps } from 'react-big-calendar';

type EmployeeResource = {
  resourceId: string;
  resourceTitle: string;
};

type ResourceTitleProps = ResourceHeaderProps<EmployeeResource> & {
  setSelectedArtists: Dispatch<SetStateAction<string[]>>;
};

function ResourceTitle({
  label,
  resource,
  setSelectedArtists,
}: ResourceTitleProps) {
  const handleClick = () => {
    setSelectedArtists([resource.resourceId]);
  };

  return (
    <Button
      variant="text"
      sx={{
        py: 1,
        my: 1,
        px: 0,
        width: '100%',
      }}
      onClick={handleClick}>
      <Typography variant="body2">{label}</Typography>
    </Button>
  );
}

export const withSelectedArtists =
  (setSelectedArtists: Dispatch<SetStateAction<string[]>>) =>
  // eslint-disable-next-line react/function-component-definition
  (props: ResourceHeaderProps<EmployeeResource>) => (
    <ResourceTitle {...props} setSelectedArtists={setSelectedArtists} />
  );

export default ResourceTitle;
